import React from "react"
import { Link } from "gatsby"
import "./accreditedPerson.scss"
import { StaticImage } from "gatsby-plugin-image"


const AccreditedPerson = () => {
    return (
        <div className="aceindustrial_academy">
            <div className="container">
                <div className="row_main">
                    {/* Left side: picture */}
                    <div className="academy_content">
                        <StaticImage
                            src="../../../assets/images/bentleyaccreditation/bentleytrainingpartner.png"
                            alt="Bentley Logo"
                            className="left-image"
                        />
                    </div>

                    {/* Right side: Title and Description */}
                    <div className="academy_info">
                        <h2 className="academy_title">Bentley Accreditation</h2>
                        <p className="academy_description">
                            We're not just saying our trainers are good—we've got the Bentley credentials to prove it.
                            With Bentley Accreditation under their belts, our instructors deliver real-world knowledge with real-world recognition.
                        </p>

                        <Link to="/theteam" className="btn_click_here" style={{ marginTop: "1.5rem" }}
                        >
                            Click Here
                        </Link>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default AccreditedPerson
